<div class="box" [class.margin-top]="marginTop" [class.margin-bottom]="marginBottom" [class.success]="isSuccess" [class.warning]="isWarning" [class.danger]="isDanger" [class.info]="isInfo" [class.success]="isSuccess2">
  <mat-icon *ngIf="isSuccess">check_circle</mat-icon>
  <mat-icon *ngIf="isDanger">warning</mat-icon>
  <ng-content></ng-content>
</div>